import React from 'react';

let dragging = false;
let startX = 0;
let startY = 0;
let currentTransformX = 0;
let currentTransformY = 0;
let activeModalDialog = null;

const getTransformValues = (transformStr) => {
  if (!transformStr || transformStr === 'none') return { x: 0, y: 0 };
  const match = transformStr.match(/translate\(([-0-9.]+)px,\s*([-0-9.]+)px\)/);
  if (match) {
    return { x: parseFloat(match[1]), y: parseFloat(match[2]) };
  }
  return { x: 0, y: 0 };
};

const handleMouseDown = (e) => {
  // Only trigger on left click on ant-modal-header or ant-modal-title
  const headerElem = e.target.closest('.ant-modal-header');
  if (!headerElem) return;

  // Do not drag if clicking close button or header controls
  if (e.target.closest('.ant-modal-close') || e.target.tagName === 'BUTTON' || e.target.tagName === 'INPUT') {
    return;
  }

  const modalElem = headerElem.closest('.ant-modal');
  if (!modalElem) return;

  dragging = true;
  activeModalDialog = modalElem;

  const currentTransform = getTransformValues(modalElem.style.transform);
  currentTransformX = currentTransform.x;
  currentTransformY = currentTransform.y;

  startX = e.clientX;
  startY = e.clientY;

  headerElem.style.cursor = 'move';
  document.addEventListener('mousemove', handleMouseMove);
  document.addEventListener('mouseup', handleMouseUp);
};

const handleMouseMove = (e) => {
  if (!dragging || !activeModalDialog) return;
  const moveX = e.clientX - startX;
  const moveY = e.clientY - startY;

  const nextX = currentTransformX + moveX;
  const nextY = currentTransformY + moveY;

  activeModalDialog.style.transform = `translate(${nextX}px, ${nextY}px)`;
};

const handleMouseUp = () => {
  dragging = false;
  activeModalDialog = null;
  document.removeEventListener('mousemove', handleMouseMove);
  document.removeEventListener('mouseup', handleMouseUp);
};

// Global event delegation for modal headers
document.addEventListener('mousedown', handleMouseDown);

// Inject header style to show move cursor on hover for all modal headers
const style = document.createElement('style');
style.innerHTML = `
  .ant-modal-header {
    cursor: move !important;
    user-select: none;
  }
`;
document.head.appendChild(style);
